module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-2500.08ec2771.svg";